import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Input from '../../Components/shared/Input';
import { fetchData, fetchFormData } from '../../utils/options';
import topTost from '../../utils/topTost';

const StateCreate = () => {
    const { id } = useParams(); // to check if we're in edit mode
    const navigate = useNavigate();
    const [state, setState] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    console.log(state)

    const fetchStateDetails = async (id) => {
        try {
            const result = await fetchData(`state/details/${id}`, {}, 'POST');

            if (result && result.state) {
                setState(result.state.state_title);
            } else {
                console.warn('State data not found.');
                setState('');
            }
        } catch (error) {
            console.error('Failed to fetch user details:', error);
            setState('');
        }
    };



    useEffect(() => {
        if (id) {
            fetchStateDetails(id);
        }
    }, [id]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Create a FormData object
        const formData = new FormData();
        formData.append("state_title", state);
        formData.append("state_description", state);
        formData.append("status", 1);

        try {
            let res;

            if (id) {
                // Edit logic - update role
                res = await fetchFormData("state/update/" + id, formData, "POST");
                console.log("Updating role:", id, formData);
            } else {
                // Create logic - new role
                res = await fetchFormData("add-state", formData, "POST");
                console.log("Creating new role:", formData);
            }

            if (res && res.code === 200) {

                topTost({
                    title: res.message,
                    icon: "success",
                });
                navigate('/master/state-list')
                console.log('Role operation successful', res);
            } else {
                console.error('Role operation failed', res);
            }
        } catch (error) {
            console.error("Submit error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleChange = (e) => {
        setState(e.target.value);
    };

    return (
        <>

            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <hr className="mt-0" />
                    <div className="card-body general-info">
                        <div className="mb-5 d-flex align-items-center justify-content-between">
                            <h5 className="fw-bold mb-0 me-4">
                                <span className="d-block mb-2">{id ? 'Edit State:' : 'Add State:'}</span>
                            </h5>
                        </div>

                        <form onSubmit={handleSubmit} className='row g-3'>
                            <div className="col-lg-6">
                            <Input
                                label="State"
                                labelId="stateInput"
                                placeholder="Enter state"
                                name="state"
                                value={state}
                                onChange={(name, value) => setState(value)}
                                icon="feather-compass"
                                required
                            />
                            </div>
                             <div className="col-lg-6">
                          
                                <button type="submit" className="btn btn-lg btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : id ? 'Update' : 'Submit'}
                                </button>
                           
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StateCreate;
